// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__37wwn","icon":"style_icon__jvp7G","messageContainer":"style_messageContainer__2SEvf","message":"style_message__3Rf0Y","detail":"style_detail__J3HNd"};